import { ISelectValues } from "../../../component/ISelectValues";

const PINK = "accent.transparent";
const GREEN = "success.transparent";
const RED = "error.transparent";

export const ID_FILTER_STATUS = "status";
export const ID_FILTER_TYPE = "type";
export const ID_FILTER_NETWORK_CODE = "networkCode";
export const ID_FILTER_EXPIRATION_DATE_FROM = "expirationDateFrom"
export const ID_FILTER_EXPIRATION_DATE_TO = "expirationDateTo";

export const NETWORK_CODE: ISelectValues[] = [
    {
        value: "06",
        label: "types.networkcode.PAN"
    },
    {
        value: "95",
        label: "types.networkcode.CUSTOMER_PAN_ALIAS"
    },
    {
        value: "98",
        label: "types.networkcode.PAN_ALIAS"
    }
];

export const TYPES: ISelectValues[] = [
    {
        value: "A",
        label: "types.CHARGE"
    },
    {
        value: "S",
        label: "types.REVERSAL"
    }
];

export const TRANSACTION_STATUSES: ISelectValues[] = [
    {
        value: "PROCESSING",
        label: "types.statuses.PROCESSING",
        color: PINK,
    },
    {
        value: "SUCCEEDED",
        label: "types.statuses.SUCCEEDED",
        color: GREEN,
    },
    {
        value: "FAILED",
        label: "types.statuses.FAILED",
        color: RED,
    }
];

export const getSummaryFields = () => {
    return [
      "FAILED",
      "SUCCEEDED",
      "PROCESSING"
    ];
  }


export const convertTypology = (type: ISelectValues[], value: string) => {
    const item = type.find((item) => item.value === value);
    return item ? item.label : value;
}

export const convertNetworkCode = (data: any) => {
    const { card } = data || {}; 
    
    switch (card?.networkCode) {
        case "06":
            return card?.pan;
        case "95":
            return card?.panAliasCustomer;
        case "98":
            return card?.panAlias;
        default:
            return "---";
    }
};

export const transactionDefaultValues = {
    [ID_FILTER_TYPE]: "",
    [ID_FILTER_NETWORK_CODE]: [],
    [ID_FILTER_STATUS]: [],
    [ID_FILTER_EXPIRATION_DATE_FROM]: null,
    [ID_FILTER_EXPIRATION_DATE_TO]: null,
};

